// eslint-disable-next-line no-redeclare
/* global window */
import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {snackbarStyles} from '../snackbar'
import {Snackbar as RmwcSnackbar, SnackbarAction as RmwcSnackbarAction} from '@rmwc/snackbar'
import '@rmwc/snackbar/styles'

const StyledRmwcSnackbar = styled(RmwcSnackbar)`
  ${snackbarStyles}
`

const SnackbarUncontrolledQueue = ({messages, removeMessage, dismissesOnAction = true, leading = true, timeout = 4000, ...defaultSnackbarProps}) => {
  const currentMessage = messages?.[0] || null
  const [, setIteration] = useState(0)
  const [message, setMessage] = useState(currentMessage)

  useEffect(() => {
    let timerId
    const doChange = () => {
      if (currentMessage !== message) {
        setIteration((val) => val + 1)
        timerId = window.setTimeout(() => setMessage(currentMessage), 150)
      }
    }
    doChange()
    return () => {
      timerId && clearTimeout(timerId)
    }
  }, [JSON.stringify(messages)])

  const {body = '', image, title = '', onClose, actions, ...messageSnackbarProps} = message || {}

  const actionProp = actions ? actions.map(({title, label, ...rest}, index) => <RmwcSnackbarAction {...rest} label={label || title} key={index} />) : null

  // We are open if we have a message
  // and the current one is the one in state
  const open = message && message === currentMessage

  return (
    <StyledRmwcSnackbar
      dismissesOnAction={dismissesOnAction}
      leading={leading}
      timeout={timeout}
      {...defaultSnackbarProps}
      {...messageSnackbarProps}
      open={open}
      message={
        <>
          {title}
          {!!title && !!body && <br />}
          {body}
          {!!image && (
            <div
              className="rmwc-snackbar__image"
              style={{
                margin: '1rem auto',
                textAlign: 'center'
              }}>
              <img src={image} alt={`${image}`} style={{maxWidth: '100%', maxHeight: '18rem'}} />
            </div>
          )}
        </>
      }
      onClose={(evt) => {
        onClose?.(evt)
        removeMessage(message)
      }}
      action={actionProp}
    />
  )
}

SnackbarUncontrolledQueue.propTypes = {
  messages: PropTypes.array.isRequired,
  removeMessage: PropTypes.func.isRequired,
  dismissIcon: PropTypes.bool,
  dismissesOnAction: PropTypes.bool,
  leading: PropTypes.bool,
  stacked: PropTypes.bool,
  timeout: PropTypes.number
}

export {SnackbarUncontrolledQueue}
